import React from "react";

const SearchFilter = ({
  searchTerm,
  setSearchTerm,
  statusFilter,
  setStatusFilter,
  filterDate,
  setFilterDate,
  statusOptions = ["Sign In", "Sign Out"],
}) => {
  return (
    <div className="date-filters">
      {setSearchTerm && (
        <div className="date-filter-group-search">
          <h4>Search</h4>
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm || ""}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
      )}

      {setStatusFilter && (
        <div className="date-filter-group-select">
          <h4>Status</h4>
          <select
            value={statusFilter || ""}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="status-select"
          >
            <option value="">All Status</option>
            {statusOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      )}

      {setFilterDate && (
        <div className="date-filter-group">
          <h4>Visitor Date</h4>
          <label>
            Date :
            <input
              className="styled-date"
              type="date"
              value={filterDate || ""}
              onChange={(e) => setFilterDate(e.target.value)}
            />
          </label>
        </div>
      )}
    </div>
  );
};

export default SearchFilter;